import {
  CharField,
  ImageField,
  NumberField,
} from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { GruppoDiRicercaFormType } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function GruppoDiRicercaForm({ col = 8 }: { col?: number;  }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<GruppoDiRicercaFormType>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.nome}
        onChange={(value) => {
          setFieldValue("nome", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "nome") : undefined}
        errorMessage={getIn(errors, "nome")}
        required
      />
      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.descrizione}
        onChange={(value) => {
          setFieldValue("descrizione", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "descrizione") : undefined}
        errorMessage={getIn(errors, "descrizione")}
        required
      />
      <WysiwygField
        label="Informazioni aggiuntive"
        layout="horizontal"
        value={values.informazioni_aggiuntive}
        onChange={(value) => {
          setFieldValue("informazioni_aggiuntive", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "informazioni_aggiuntive") : undefined}
        errorMessage={getIn(errors, "informazioni_aggiuntive")}
      />
      <ImageField
        label="Immagine"
        layout="horizontal"
        value={values.immagine}
        onChange={(value) => {
          setFieldValue("immagine", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "immagine") : undefined}
        errorMessage={getIn(errors, "immagine")}
        required
      />
      <NumberField
        label="Ordine"
        layout="horizontal"
        value={values.ordine}
        onChange={(value) => {
          setFieldValue("ordine", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "ordine") : undefined}
        errorMessage={getIn(errors, "ordine")}
        required
      />
    </Col>
  )
}
